<template>
        <div class="medical-card">
            <ul class="profile-list">
                <li v-for="medicalCard in medicalCards" :key="medicalCard.id"><input type="radio" v-model="selectedMedicalCardId" :value="medicalCard.id" :id="'id-'+ medicalCard.id" :checked="selectedMedicalCardId == medicalCard.id"> <label :for="'id-'+ medicalCard.id">{{ medicalCard.name }}</label></li>
            </ul>
            <button v-if="!showForm" @click="showForm = !showForm" class="createProfile">Создать новый профиль</button>
            <div class="form-wrapp" v-if="showForm">
                <div class="inputs-container">
                    <input type="text" v-model="inputs.firstName" placeholder="Имя">
                    <input type="text" v-model="inputs.lastName" placeholder="Фамилия">
                    <input type="text" v-model="inputs.middleName" placeholder="Отчество">
                    <cleave v-model="inputs.birthdate" v-bind:class="{ errorinput: error.exist }" class="form-control" :options="options.date" :raw="false" placeholder="Дата рождения: дд.мм.гг"></cleave>
                </div>
                <div>
                    <button type="submit" :disabled="lockButton" @click="createButtonHandler()">Создать профиль</button>
                </div>
            </div>
            <div v-if="error.exist" class="error">{{ error.message }}</div>
        </div>
</template>

<script>
    import _ from 'lodash';
    import Cleave from 'vue-cleave-component';

    import './medicalCard.scss'

    import { bus } from '../../main'

    export default {
        name: 'MedicalCard',
        props: ['user'],
        data() {
            return {
                inputs: {
                    firstName: '',
                    lastName: '',
                    middleName: '',
                    birthdate: '',
                },
                error: {
                    exist: false,
                    message: '',
                    type: ''
                },
                showForm: false,
                selectedMedicalCardId: null,
                options: {
                    date: {
                        date: true,
                        datePattern: ['d', 'm', 'Y'],
                        delimiter: '.',
                    },
                },
                medicalCards: []
            }
        },
        methods: {
            clearError(type) {
                if (this.error.type === type) {
                    this.error.type = '';
                    this.error.exist = false;
                    this.error.message = '';
                }
            },
            clearInputs(){
                this.inputs.firstName = '';
                this.inputs.lastName = '';
                this.inputs.middleName = '';
                this.inputs.birthdate = '';
            },
            selectMedicalCard(medicalCardId) {
                const self = this;

                const medicalCard = _.find(self.medicalCards, {id: medicalCardId});

                this.$emit('select-medical-card', medicalCard);
            },
            createButtonHandler() {
                const self = this;

                this.createMedicalCard().then(function (medical_card) {
                    bus.$emit('laboratoryLanding.analytics', {action: 'createMedicalCard'});

                    self.medicalCards.push(medical_card);
                    self.selectedMedicalCardId = medical_card.id;
                    self.showForm = false;
                    self.clearInputs();
                });
            },
            getMedicalCards() {
                const self = this;
                return new Promise((resolve, reject) => {
                    let url = process.env.VUE_APP_HOST + '/mobile/user/medical_card/get_medical_cards_list/';

                    fetch(url, {
                        headers: new Headers({
                            'Authorization': 'Token ' + self.user.session,
                        }),
                    }).then((response) => {
                        response.json().then(function (data) {
                            if (data.status === 'OK') {
                                resolve(data.medical_cards);
                            } else {
                                reject(data.message);
                                self.error.exist = true;
                                self.error.message = data.message;
                            }
                        })
                    }, () => {
                        self.error.exist = true;
                        self.error.message = 'Возникла неизвестная ошибка';

                        reject(self.error.message);
                    })
                })
            },
            createMedicalCard() {
                const self = this;

                return new Promise((resolve, reject) => {
                    let url = process.env.VUE_APP_HOST + '/mobile/user/medical_card/create_medical_card/';

                    const formData = new FormData();

                    let name = this.inputs.firstName + ' ' + this.inputs.lastName;
                    if (this.inputs.middleName) {
                        name += ' ' + this.inputs.middleName;
                    }

                    const birthdateSplitted = this.inputs.birthdate.split('.');

                    formData.append('name', name);
                    formData.append('birthday', birthdateSplitted[2] + '-' + birthdateSplitted[1] + '-' + birthdateSplitted[0]);

                    fetch(url, {
                        method: 'POST',
                        headers: new Headers({
                            'Authorization': 'Token ' + self.user.session,
                        }),
                        body: formData
                    }).then((response) => {
                        response.json().then(function (data) {
                            if (data.status === 'OK') {
                                resolve(data.medical_card);
                            } else {
                                self.error.type = 'createMedicalCard';
                                self.error.exist = true;
                                self.error.message = data.message;

                                reject(self.error.message);
                            }
                        })
                    }, () => {
                        self.error.type = 'createMedicalCard';
                        self.error.exist = true;
                        self.error.message = 'Возникла неизвестная ошибка';

                        reject(self.error.message);
                    })
                });
            }
        },
        mounted() {
            const self = this;

            if (!this.medicalCards.length) {
                this.getMedicalCards().then(function (medicalCards) {
                    _.each(medicalCards, function (medical_card) {
                        self.medicalCards.push(_.extend(medical_card, {selected: false}))
                    });

                    if (self.medicalCards.length) {
                        self.selectedMedicalCardId = self.medicalCards[0].id;
                    }
                });
            }
        },
        watch: {
            inputs: {
                handler() {
                    this.clearError('createMedicalCard');
                },
                deep: true
            },
            selectedMedicalCardId: function () {
                this.selectMedicalCard(this.selectedMedicalCardId)
            }
        },
        computed: {
            lockButton: function () {
                return !(this.inputs.firstName !== '' && this.inputs.birthdate !== '')
            }
        },
        components: {
            Cleave
        },
    }
</script>
